import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import PropertySection from './section-components/property';
import Footer from './global-components/footer-v2';

const Property = () => {
    return <div>
        <Navbar />
        <PageHeader header="Units" from='units' subheader="Units" />
        <PropertySection />
        <Footer />
    </div>
}

export default Property;

